// extracted by mini-css-extract-plugin
module.exports = {"stars":"StarBackground_stars__2nf6M","animStar":"StarBackground_animStar__-jSLG","stars2":"StarBackground_stars2__29fdK","stars3":"StarBackground_stars3__1tnIv"};